import { ComissionsShortDataT } from "@interfaces/internal-study/comissions";
import { ComissionMember } from "@interfaces/store/comissions-store-types";

import Fetcher from "@http/fetcher";
import { ResCallback } from "@interfaces/common";

class InternalStudyComissionsService {
  static async getAll(
    companyId: number,
    cb: ResCallback<ComissionsShortDataT[]>
  ) {
    try {
      const res = await Fetcher.get<ComissionsShortDataT[]>(
        "/educational-center/internal-training/comissions",
        {
          params: {
            companyId,
          },
        }
      );

      if (res.status === 200) {
        cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async create(
    companyId: number,
    title: string,
    order_number: string,
    order_date: string,
    chairman: ComissionMember,
    members: ComissionMember[],
    cb: ResCallback<ComissionsShortDataT>
  ) {
    try {
      const res = await Fetcher.post<ComissionsShortDataT>(
        "/educational-center/internal-training/comissions",
        {
          companyId,
          title,
          order_number,
          order_date,
          chairman,
          members,
        }
      );

      if (res.status === 201) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async update(
    comissionId: number,
    title: string,
    order_number: string,
    order_date: string,
    chairman: ComissionMember,
    members: ComissionMember[],
    cb: ResCallback<string>
  ) {
    try {
      const res = await Fetcher.patch<string>(
        `/educational-center/internal-training/comissions/${comissionId}`,
        {
          title,
          order_number,
          order_date,
          chairman,
          members,
        }
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }

  static async delete(comissionId: number, cb: ResCallback<string>) {
    try {
      const res = await Fetcher.delete<string>(
        `/educational-center/internal-training/comissions/${comissionId}`
      );

      if (res.status === 200) {
        return cb(null, res);
      }
    } catch (err: any) {
      cb(err);
    }
  }
}

export default InternalStudyComissionsService;
